import axios from "axios";

const token = localStorage.getItem("token");

const params = {
    headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
    },
}

export const fetchDataFromApi = async (url) => {
    try {
        const { data } = await axios.get(process.env.REACT_APP_BASE_URL + url, params);
        return data;
    } catch (error) {
        console.log(error);
        return error;
    }
}

export const uploadImage = async (url, formData) => {
    try {
        const { data } = await axios.post(process.env.REACT_APP_BASE_URL + url, formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        });
        return data;
    } catch (error) {
        console.error('Upload error:', error);
        return error;
    }
}

export const postData = async (url, formData) => {
    try {
        const response = await fetch(process.env.REACT_APP_BASE_URL + url, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)
        });

        if (response.ok) {
            const data = await response.json();
            return data;
        } else {
            const errorData = await response.json();
            return errorData;
        }
    } catch (error) {
        console.error('Error:', error);
        return error;
    }
}

// FIXED: This was the main issue - wrong destructuring and missing headers
export const editData = async (url, updatedData) => {
    try {
        console.log('=== EDIT DATA REQUEST ===');
        console.log('URL:', `${process.env.REACT_APP_BASE_URL}${url}`);
        console.log('Data:', updatedData);
        console.log('Token:', token ? 'Present' : 'Missing');

        const response = await axios.put(`${process.env.REACT_APP_BASE_URL}${url}`, updatedData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });

        console.log('=== EDIT DATA RESPONSE ===');
        console.log('Status:', response.status);
        console.log('Data:', response.data);

        // Return the actual response data
        return response.data;

    } catch (error) {
        console.error('=== EDIT DATA ERROR ===');
        console.error('Error:', error);
        console.error('Response:', error.response?.data);
        console.error('Status:', error.response?.status);

        // Return error in a format that matches your error handling
        if (error.response?.data) {
            return error.response.data;
        } else {
            return {
                success: false,
                error: error.message || 'Network error'
            };
        }
    }
}

// FIXED: This function had incorrect parameters
export const deleteImages = async (url, imageData) => {
    try {
        const { data } = await axios.delete(`${process.env.REACT_APP_BASE_URL}${url}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            data: imageData // Use 'data' property for DELETE request body
        });
        return data;
    } catch (error) {
        console.error('Delete images error:', error);
        return error.response?.data || error;
    }
}



// api.js file এ
export const deleteData = async (url) => {
    try {
        console.log('Making DELETE request to:', `${process.env.REACT_APP_BASE_URL}${url}`);

        const { data } = await axios.delete(`${process.env.REACT_APP_BASE_URL}${url}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            }
        });

        console.log('DELETE response:', data);
        return data;
    } catch (error) {
        console.error('Delete error:', error.response?.data || error);
        throw error.response?.data || error;
    }
}


// This one was already correct
export const patchData = async (url, updateFields) => {
    try {
        const response = await fetch(process.env.REACT_APP_BASE_URL + url, {
            method: 'PATCH',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(updateFields || {})
        });

        if (response.ok) {
            const data = await response.json();
            return data;
        } else {
            const errorData = await response.json();
            throw new Error(errorData.message || 'PATCH request failed');
        }
    } catch (error) {
        console.error('PATCH Error:', error);
        throw error;
    }
}
